export default "__VITE_ASSET__BvOeq_Gj__"